import {
  FAILURE_OFFICE_MANAGEMENT_DATA,
  LOADING_OFFICE_MANAGEMENT_DATA,
  SET_OFFICE_MANAGEMENT_DATA,
  SUCCESS_OFFICE_MANAGEMENT_DATA,
} from "../constants/office-management";
import { Action, OfficeManagementData } from "../models/office-management";
import { Office } from "../types";

const initialState: OfficeManagementData = {
  status: "",
  hasAccessToAllOffices: false,
  data: [],
};

const officeManagementReducer = (state: OfficeManagementData = initialState, action: Action): OfficeManagementData => {
  switch (action.type) {
    case SET_OFFICE_MANAGEMENT_DATA: {
      action.payload.offices.sort((a: Office, b: Office) => a.customWeight - b.customWeight);
      if (action.payload.deactivateOffices) {
        return {
          ...state,
          data: [...action.payload.offices, ...action.payload.deactivateOffices],
          hasAccessToAllOffices: action.payload.hasAccessToAllOffices,
        };
      } else {
        return {
          ...state,
          data: action.payload.offices,
          hasAccessToAllOffices: action.payload.hasAccessToAllOffices,
        };
      }
    }

    case FAILURE_OFFICE_MANAGEMENT_DATA:
      return { ...state, status: "ERROR" };
    case SUCCESS_OFFICE_MANAGEMENT_DATA:
      return { ...state, status: "SUCCESS" };
    case LOADING_OFFICE_MANAGEMENT_DATA:
      return { ...state, status: "LOADING" };
    default:
      return state;
  }
};

export default officeManagementReducer;
